import _ from 'lodash';
import defaultState from 'us_pcb_assembly/data/defaultState';

import { PRICE_SELECTED, QUOTED } from 'pu-data/QuoteSteps';

const state = {
  ...defaultState,
}

if (Spree.quote) {
  state.quote = Spree.quote;
}

if (Spree.quote_parameters) {
  if (!Spree.quote_parameters.bga) {
    Spree.quote_parameters.bga = "0";
  }

  state.parameters = Object.assign({}, state.parameters, Spree.quote_parameters);

  if (Spree.quote_parameters.supplier_selected) {
    state.quoteStep = PRICE_SELECTED;
  } else {
    state.quoteStep = QUOTED;
  }
}

export default state;